import React, { useEffect, useState } from "react";
import DisplayUploads from "./DisplayUploads";
import "./Books.css";
import SearchBar from "../SearchBar/SearchBar";
import { Link } from "react-router-dom";

const Books: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [debouncedQuery, setDebouncedQuery] = useState<string>("");

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  return (
    <div className="books-container">
      <div className="featured-books-container">
        <div className="books-subnav">
          <div className="books-links">
            <Link to="/upload" className="books-link primary-button">
              Upload a Book
            </Link>
          </div>
          <SearchBar onSearch={handleSearch} />
        </div>
        <DisplayUploads searchQuery={debouncedQuery} />
      </div>
    </div>
  );
};

export default Books;
